// super-excalidraw: thin client for the /api/library endpoints. Used by the
// debounced sync that mirrors the user's local Excalidraw library to MinIO,
// so it (a) survives browser-storage wipes, (b) syncs across devices, and
// (c) becomes available to the AI generation backend.

export type LibraryItemDTO = {
  id: string;
  status?: "published" | "unpublished" | string;
  name?: string;
  description?: string;
  folderId?: string;
  created?: number;
  // raw shape elements from Excalidraw's LibraryItem.elements
  elements?: unknown;
};

export type LibraryDTO = {
  items: LibraryItemDTO[];
  updatedAt?: number;
};

const base = "/api/library";

export async function fetchLibrary(): Promise<LibraryDTO> {
  const r = await fetch(base + "/");
  if (!r.ok) {
    throw new Error(`library fetch ${r.status}`);
  }
  return r.json();
}

export async function putLibrary(lib: LibraryDTO): Promise<void> {
  const r = await fetch(base + "/", {
    method: "PUT",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify(lib),
  });
  if (!r.ok) {
    throw new Error(`library put ${r.status}`);
  }
}

export async function patchLibraryItem(
  id: string,
  patch: { name?: string; description?: string; folderId?: string },
): Promise<void> {
  const r = await fetch(`${base}/${encodeURIComponent(id)}`, {
    method: "PATCH",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify(patch),
  });
  if (!r.ok) {
    throw new Error(`library patch ${r.status}`);
  }
}
